export function generateNewId(ids: number[]): number {
  const highestId = ids.length > 0 ? Math.max(...ids) : 0;
  return highestId + 1;
}
